
/*
 * DISTRIBUTION STATEMENT C. Distribution authorized to U.S. Government Agencies and their contractors; Critical
 * Technology; 19 October 2017. Other requests for this document shall be referred to Chemical and Biological
 * Technologies, Defense Threat Reduction Agency, 8725 John J Kingman Road, Fort Belvoir, VA 22060-6201.
 *
 * WARNING: This document contains technical data whose export is restricted by the Arms Export Control Act (Sec 2751
 * of Title 22, United States Code) or the Export Control Reform Act of 2018 (Chapter 58 Sections 4801-4852 of Title
 * 50, United States Code). Violations of these export laws are subject to severe criminal penalties. Disseminate in
 * accordance with provisions of DoD Directive 5230.25 and DoD Instruction 2040.02. DESTRUCTION NOTICE: For
 * unclassified, limited distribution documents, destroy by any method that will prevent disclosure of the contents
 * or reconstruction of the document.
 *
 * This material is based upon work supported by the Under Secretary of War for Research and Engineering under Air
 * Force Contract No. FA8702-15-D-0001 or FA8702-25-D-B002. Any opinions, findings, conclusions or recommendations
 * expressed in this material are those of the author(s) and do not necessarily reflect the views of the Under
 * Secretary of War for Research and Engineering.
 *
 * © 2026 Massachusetts Institute of Technology.
 *
 * The software/firmware is provided to you on an As-Is basis
 *
 * Delivered to the U.S. Government with Unlimited Rights, as defined in DFARS Part 252.227-7013 or 7014 (Feb 2014).
 * Notwithstanding any copyright notice, U.S. Government rights in this work are defined by DFARS 252.227-7013 or
 * DFARS 252.227-7014 as detailed above. Use of this work other than as specifically authorized by the U.S.
 * Government may violate any copyrights that exist in this work.
 *
 * This document contains Controlled Unclassified Information (CUI). Handling of this information is subject to the
 * controls identified in DFARS 252.204-7012 - SAFEGUARDING COVERED DEFENSE INFORMATION AND CYBER INCIDENT REPORTING.
 */

export function tagStyles() {
  return {
    collected_by_tag: {
    },
    exposure_type_tag: {
    },
    general_data_type_tag: {
    },
    phenotype_type_tag: {
    },
    sample_type_tag: {
    },
    data_classification_tag: {
    },
    sponsor_tag: {
    },
    study_type_tag: {
    },
    truth_tag: {
    },
    in_vivo_assay_tag: {
    },
    in_vitro_assay_tag: {
    }
  }
}

export function formStyles() {
  return {
    dark_title: {
      color: "darkslategray"
    },
    required_title: {
      color: 'darkslategray'
    },
    required_title_empty: {
      color: 'red'
    },
    non_required_title: {
      color: "darkslategray"
    },
    numbered_section: {
      color: "darkslategray"
    },
    fieldDescription: {
      color: 'darkgrey',
      fontSize: 'calc(11px + 0.3vmin)',
      margin: '0 0 5px 4px',
    },
  }
}

export function classificationStyles() {
  // https://www.astrouxds.com/components/classification-markings/#overall-marking-background-information
  return {
    unclassified: {
      backgroundColor: '#007a33 !important',
      color: 'white !important'
    },
    controlled: {
      backgroundColor: '#502b85 !important',
      color: 'white !important'
    },
    confidental: {
      backgroundColor: '#0033a0 !important',
      color: 'white !important'
    },
    secret: {
      backgroundColor: '#c8102e !important',
      color: 'white !important'
    },
    top_secret: {
      backgroundColor: '#ff8c00 !important',
      color: 'black !important'
    },
    top_secret_sci: {
      backgroundColor: '#fc383a !important',
      color: 'black !important'
    }
  }
}